import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { createSearchPOIsFromAddressStore, createSearchPoisStore, enrichPoisStoreWithSelectedPoiData, getPoisStore } from '$routes/(map)/loadPois';

export const load = (async (event) => {
	const { searchParams } = await event.parent();
	const { page, selectedPoi } = searchParams;

	const poisStoreWithoutSelectedPoiData = await getPoisStore({
		event,
		searchPOIStore: createSearchPoisStore(),
		searchPOIFromAddressStore: createSearchPOIsFromAddressStore(),
	});

	const poisStore = await enrichPoisStoreWithSelectedPoiData(
		poisStoreWithoutSelectedPoiData,
		selectedPoi,
		event,
	);

	return {
		page,
		poisStore,
		mobileTopButtons: ['search', 'back-overview'],
		pagename: selectedPoi ? routesPagename[`${selectedPoi.type}_DATASHEET`] : undefined,
	};
}) satisfies PageLoad;
